export default {"src":"/_next/static/media/Refinery29_logo.fedf3b21.svg","height":330,"width":518,"blurWidth":0,"blurHeight":0};